module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-1.1eb2ae3a.jpg";